import { ServerProduct } from '@/lib/janitsjar/Product';
import ImageCarousel from '@/components/imageCarousel';

export type ProductGalleryProps = {
  product: ServerProduct;
  children?: any;
};

export function ProductGallery({ product, children }: ProductGalleryProps) {
  const { media = [] } = product;

  if (!media || media.length === 0) return null;

  return (
    <div className="md:col-span-6 rounded-lg relative">
      <div className="md:sticky md:top-16 print:!static">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={media[0].url}
          className="hidden print:block h-[6cm]"
          alt="Bilde av produkt ikke lastet"
          aria-hidden="true"
        />
        <ImageCarousel
          className="print:hidden"
          media={media.map((image) => ({
            url: image.url,
            key: image.id,
            assetType: image.type,
          }))}
          alt={[product.posterName || 'Bilde av produkt']}
          mainImageSizes="(max-width: 375px) 273px, (max-width: 640px) calc(100vw - 4rem), (max-width: 1024px) 336px, (max-width: 1256px) 432px, 504px"
        />
        {children}
      </div>
    </div>
  );
}

export default ProductGallery;
